<template>
  <div>
    <div id="print">
      <div>
        <div>
          <center><h4>付款指示书</h4></center>
        </div>
        <div class="titles">
          <span>
            典当行： <u>{{ $store.state.name }}</u></span
          >
          <div>
            当户： <u>{{ msgVal.name }}</u> 在你典当行于
            <span class="footer_da"><span>年</span> <span>月</span><span>日</span></span>
            《机动车质押典当合同》以及当票，现本人指示贵典当行将当票 当金<span
              ><u>{{ msgVal.sum }}</u></span
            >
            元,支付至以下收款帐户，即为本人收讫：
          </div>
          <div class="kh">
            <span>户名：</span>
            <span>账号:</span>
            <span>开户行:</span>
          </div>
          <div>
            <div class="zs">
              <div>
                <span class="z_name">指示人： </span>
              </div>
              <div class="footer_d"><span>年</span> <span>月</span><span>日</span></div>
            </div>
          </div>
        </div>
      </div>

      <div class="bot">
        <div>
          <center><h4>收款确认书</h4></center>
        </div>
        <div class="titles">
          <span>
            典当行： <u>{{ $store.state.name }}</u></span
          >
          <div>
            当户： <u>{{ msgVal.name }}</u> 收到典当质押车牌<u>{{
              msgVal.plateNumber
            }}</u>
            汽车典当款项<u>{{ msgVal.sum }}</u
            >元 ,车内无遗漏贵重的私人物品（典当行已提醒）。
            （当金支付方式:以银行转账电子回单记录作为当金支付依据）
          </div>

          <div>
            <div class="zs">
              <div>
                <span class="z_name">收款人： </span>
              </div>
              <div class="footer_d"><span>年</span> <span>月</span><span>日</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bTn">
      <button v-print="'#print'">打印合同</button>
      <!-- <el-button type="primary">打 印 合 同</el-button> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "ReceiPt",
  props: ["msgVal"],
  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
.titles {
  display: flex;
  flex-direction: column;
}
.kh {
  margin: 20px;
  display: flex;
  flex-direction: column;
}
.footer_d {
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.footer_da {
  margin-left: 50px;
  width: 10%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.zs {
  display: flex;
  flex-direction: column;

  align-items: end;
  /* float: right; */
}
.z_name {
  margin-right: 50px;
}
.bot {
  margin: 50px auto;
}
.bTn {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
